import e from "@dialpad/dialtone-tokens/layered/themes/tokens-arctic-colors.css?inline";
//#region themes/arctic.js
var t = {
	brand: {
		css: e,
		name: "arctic"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
